import React from 'react';

import { HighlightedText } from '../embedExplorerModal/HighlightedText';

import { SandboxEmbedCodeSnippetConfig } from './EmbedSandboxCodeSnippetConfig';

export const JSONOptionsSnippet = ({
  initialEndpoint,
  initialState,
}: SandboxEmbedCodeSnippetConfig) => (
  <>
    {`{
    target: `}
    '<HighlightedText>#embedded-sandbox</HighlightedText>'
    {`,
    initialEndpoint: `}
    '
    <HighlightedText>
      {initialEndpoint || 'http://localhost:4000'}
    </HighlightedText>
    ',
    {initialState && (
      <>
        {`
    initialState: {
      document: `}
        <HighlightedText>{`\`${initialState.document}\``}</HighlightedText>
        {`,
      variables: `}
        <HighlightedText>
          {initialState.variables && initialState.variables.length
            ? initialState.variables.toString()
            : '{}'}
        </HighlightedText>
        {`,
      headers: `}
        <HighlightedText>
          {initialState.headers && initialState.headers.length
            ? initialState.headers.toString()
            : '{}'}
        </HighlightedText>
        {`,
      includeCookies: `}
        <HighlightedText>
          {initialState.includeCookies ?? 'false'}
        </HighlightedText>
        ,
        {`
    },`}
      </>
    )}
    {`
  }`}
  </>
);
